export default "__VITE_ASSET__dqwjdQnM__"